import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';
import { ListingCard, Heading, NamedLink } from '../../../components';
import css from './TopPicksPanel.module.css';

/**
 * TopPicksPanel displays up to 3 favourited listings from the 'repoze supply' user.
 * Layout: title + button on the left, 3 listing cards across the right.
 * Only renders if listings are available.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Additional CSS class
 * @param {string} [props.rootClassName] - Override root CSS class
 * @param {Array} props.listings - Array of listing objects (max 3)
 * @returns {JSX.Element|null} Top picks panel or null if no listings
 */
const TopPicksPanel = props => {
  const {
    className,
    rootClassName,
    listings = [],
  } = props;

  if (!listings || listings.length === 0) {
    return null;
  }

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.panel}>
        <div className={css.titleBlock}>
          <Heading as="h2" rootClassName={css.title}>
            <FormattedMessage id="TopPicksPanel.title" />
          </Heading>
          <NamedLink
            name="SearchPage"
            to={{ search: '?sort=createdAt' }}
            className={css.exploreLink}
          >
            <FormattedMessage id="TopPicksPanel.explorePicks" />
          </NamedLink>
        </div>
        {listings.map((listing, index) => (
          <div key={listing.id?.uuid || index} className={css.cardWrapper}>
            <ListingCard
              listing={listing}
              renderSizes="(max-width: 767px) 100vw, (max-width: 1023px) 33vw, 20vw"
              showAuthorInfo={false}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopPicksPanel;
